import { z } from 'zod';
import { ADMIN_V2_STABLE_ID_PATTERN } from './admin-v2-array-operations';

export function isAdminV2ExactIdentity(value: unknown): value is string {
  return (
    typeof value === 'string' && value.length > 0 && value.trim() === value
  );
}

const exactIdentityMessage =
  'Identity must be non-empty and must not contain leading or trailing whitespace.';

const ADMIN_V2_RENDER_CONFIG_PATH_PATTERN =
  /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/;

export const adminV2ExactIdentitySchema = z
  .string()
  .min(1)
  .refine(isAdminV2ExactIdentity, exactIdentityMessage);

export const adminV2StableIdentitySchema = z
  .string()
  .min(1)
  .regex(
    ADMIN_V2_STABLE_ID_PATTERN,
    'Identity must use the canonical stable-id format.'
  )
  .refine(isAdminV2ExactIdentity, exactIdentityMessage);

export const adminV2RenderConfigPathSchema = z
  .string()
  .min(1)
  .regex(
    ADMIN_V2_RENDER_CONFIG_PATH_PATTERN,
    'Render config path must be a dot-delimited path without whitespace.'
  );
